
<template>
  <div>
    <v-card
      class="rounded-0 mb-3"
      flat
      style="border-left: solid; border-color: grey"
      v-for="(approv, idx) in approvations"
      :key="idx"
    >
      <v-card-title
        class="subtitle-1 font-weight-bold pa-0 pl-3"
      >
        Aprovação #{{idx+1}}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="error"
              @click="removeApproval(idx)"
              v-if="approvations.length > 1"
              icon
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Excluir aprovação</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text class="pa-0 pl-3">
        <v-row>
          <v-col cols="12" class="pb-0">
            <span>Escolha o tipo de aprovação:</span>
          </v-col>
          <v-col cols="12" class="d-flex flex-wrap align-center pt-0 pb-0">
            <v-btn
              class="mr-3 my-2"
              small
              color="ckb_purple"
              rounded
              @click="approv.approvation_kind = 'yes_no'"
              :dark="approv.approvation_kind == 'yes_no' ? true : false"
              :outlined="approv.approvation_kind == 'yes_no' ? false : true"
            >
              <v-icon left>mdi-thumbs-up-down</v-icon>
              Sim ou Não
            </v-btn>
             <v-btn
              class="mr-3 my-2"
              small
              color="ckb_purple"
              rounded
              @click="approv.approvation_kind = 'signature'"
              :dark="approv.approvation_kind == 'signature' ? true : false"
              :outlined="approv.approvation_kind == 'signature' ? false : true"
            >
              <v-icon left>mdi-draw-pen</v-icon>
              Assinatura
            </v-btn>
            <v-switch
              class="mt-2"
              v-model="approv.is_approvation_mandatory"
              label="Aprovação obrigatória?"
              color="success"
              inset
              dense
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="pt-0 pb-0 pr-2">
            <v-autocomplete
              class="mb-n4"
              outlined
              dense
              v-model="approv.user_id"
              label="Usuários responśaveis pela aprovação"
              :items="users"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="6" class="pt-0 pb-0 pl-2">
            <v-select
              class="mb-n4"
              outlined
              dense
              v-model="approv.action_id"
              label="Selecione uma ação caso a etapa seja reprovada"
              :items="rejected_actions"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div class="pl-3">
      <v-btn
        color="success"
        small
        @click="addApprovation"
      >
        <v-icon left>mdi-plus</v-icon>
        Adicionar aprovação
      </v-btn>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "ApprovationStepConfig",
  data() {
    return {
      approvations: [
        {
          approvation_kind: null,
          is_approvation_mandatory: false,
          user_id: null,
          action_if_rejected: null
        }
      ],
      default_approvation: {
        approvation_kind: null,
        is_approvation_mandatory: false,
        user_id: null,
        action_if_rejected: null
      },
      users: [],
      rejected_actions: []
    }
  },
  methods: {
    removeApproval(idx) {
      this.approvations.splice(idx, 1);
    },
    addApprovation() {
      this.approvations.push({...this.default_approvation});
    },
    approvationType(kind) {
      this.approvation_kind = kind;
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      one_step_to_edit: state => state.ConfigFlow.one_step_to_edit,
    })
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>